import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'
import { Box } from '@chakra-ui/react'

import CustomIcon from '../../CustomIcon'

interface CustomIconProps extends IconProps {
  variant?: string
}

const CementCartOutline = createIcon({
  displayName: 'CementCartOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <rect width="24" height="24" fill="none" />
      <circle
        cx="8"
        cy="18"
        r="3"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M5,10V9.23607A3.618,3.618,0,0,1,7,6H7l.93934-.93934A3.62132,3.62132,0,0,1,10.5,4h0a3.62132,3.62132,0,0,1,2.56066,1.06066L14,6h0a3.618,3.618,0,0,1,2,3.23607V10"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M14.51562,17.51562l2.07017,2.07017a1.41421,1.41421,0,0,0,1,.41421h0A1.41421,1.41421,0,0,0,19,18.58579V9.07037a2,2,0,0,1,.8906-1.6641L22,6"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M11,18h2.22552a2,2,0,0,0,1.42128-.59289l3.736-3.77366A2.13289,2.13289,0,0,0,19,12.13286h0A2.13285,2.13285,0,0,0,16.86714,10H4.46837A1.46837,1.46837,0,0,0,3,11.46837H3a1.46833,1.46833,0,0,0,.34033.94L6.0882,15.70581"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </>
  ),
})

const CementCartTwoTone = createIcon({
  displayName: 'CementCartTwoTone',
  viewBox: '0 0 24 24',
  path: (
    <>
      <Box as="g" color="twoToneStrokeColor">
        <rect width="24" height="24" fill="none" />
        <Box
          as="circle"
          cx="8"
          cy="18"
          r="3"
          fill="twoToneFillColor"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <Box
          as="path"
          d="M5,10V9.23607A3.618,3.618,0,0,1,7,6H7l.93934-.93934A3.62132,3.62132,0,0,1,10.5,4h0a3.62132,3.62132,0,0,1,2.56066,1.06066L14,6h0a3.618,3.618,0,0,1,2,3.23607V10"
          fill="twoToneFillColor"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M14.51562,17.51562l2.07017,2.07017a1.41421,1.41421,0,0,0,1,.41421h0A1.41421,1.41421,0,0,0,19,18.58579V9.07037a2,2,0,0,1,.8906-1.6641L22,6"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M11,18h2.22552a2,2,0,0,0,1.42128-.59289l3.736-3.77366A2.13289,2.13289,0,0,0,19,12.13286h0A2.13285,2.13285,0,0,0,16.86714,10H4.46837A1.46837,1.46837,0,0,0,3,11.46837H3a1.46833,1.46833,0,0,0,.34033.94L6.0882,15.70581"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </Box>
    </>
  ),
})

const CementCart: FC<CustomIconProps> = (props) => {
  switch (props.variant) {
  case 'twoTone':
    return <CustomIcon as={CementCartTwoTone} {...props} />
  default:
    return <CustomIcon as={CementCartOutline} {...props} />
  }
}

export default memo(CementCart)
